import React from 'react';
import { Box, Container, Typography, Button, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';

const DirectorySection = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, position: 'relative', background: '#000000' }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            ...theme.customEffects?.glass,
            borderRadius: 5,
            px: { xs: 4, md: 8 },
            py: { xs: 6, md: 10 },
            textAlign: 'center',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: '#ffffff',
              fontWeight: 800,
              mb: 2,
              fontSize: { xs: '1.8rem', md: '2.6rem' },
              letterSpacing: '-0.03em'
            }}
          >
            Discover practitioners.
          </Typography>
          <Typography
            sx={{
              color: theme.palette.text.secondary,
              mb: 5,
              maxWidth: 600,
              mx: 'auto',
              fontSize: { xs: '1rem', md: '1.15rem' },
              lineHeight: 1.6
            }}
          >
            Browse our growing directory of independent professionals. 
            Find specialized services and book instantly.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate(ROUTES.DIRECTORY)}
              sx={{ px: 4, py: 1.5 }}
            >
              Browse Directory
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate(ROUTES.SIGNUP)}
              sx={{ px: 4, py: 1.5 }}
            >
              List Your Practice
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default DirectorySection;
